<div class="my-2 my-sm-3 title-min-height" [class.d-flex]="isInWatchlist" appHasMarkedText>
	@if (isInWatchlist) {
		<img [src]="watchlistIcon" class="me-2" height="23px" width="23px" alt="watchlistmarked" loading="lazy" />
	}
	@if (title !== '') {
		<h2 class="title fw-bold lh-normal text-larger">{{ title }}</h2>
	}
</div>
